module.exports = __webpack_public_path__ + "static/media/image-card-4.d37f118b.png";